// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dNFoG","menuLink":"styles_menuLink__yxuS9","menu":"styles_menu__CX9lI"};